import Grid from '@mui/material/Grid';
import logo from '../../assets/images/logo/logo.png';
import './print.scss';
import { useTranslation } from 'react-multi-lang';
import { useCookies } from 'react-cookie';
import { DashedInput } from './input';

interface iProps {
  children: React.ReactNode;
  title_ar: string;
  title_en?: string;
  hide_title?:boolean;
  date?:string ,
  order_no?:string
}
export default function PrintTemplate({
  children,
  title_ar,
  title_en,
  hide_title,
  date,
  order_no

}: iProps) {
  const t = useTranslation();

  const [cookies] = useCookies();

  return (

      <table style={{
        height:'100vh',
        width:'100%'
      }}>
         <tbody>
    {/* //   <Grid container margin={0} 
  
    // paddingTop={1}
    // paddingBottom={1}
    // //  display={'flex'}
    // //  flexDirection={'column'}
    // //  justifyContent={'space-between'}

    //  > */}
    <tr>
        <Grid  container 
       size={12} paddingTop={0} marginTop={0} >
     
         
          <Grid  container size={12} 
          
             paddingBottom={2}
          
       >
           
            <Grid
              
              size={12}
              display={'flex'}
              justifyContent={'flex-end'}
             flexDirection={'column'}
             alignItems={'center'}
          
             paddingX={1}
            >
              <img src={logo} className="logo" />
            </Grid>
          </Grid>

        
        
        </Grid>
           {order_no && 
           <Grid container size ={12} padding={0} display="flex" justifyContent="flex-end">
        <Grid container size={3}  
        paddingBottom={2}
          display={'flex'} justifyContent={'flex-end'} 
            flexDirection={'column'} className="prefix" >
            <div className="flex  space-between fs-12" >
              <div>{order_no}</div>
              <div>{" : "}</div>
                <div> رقم الطلبية</div>
              </div>
       
              
        </Grid>
      </Grid>}
      {!hide_title &&
        <Grid  container size={12} justifyContent="center"
        >
        <div className=" title" style={{ margin: '0 5px' }}>
          {title_ar}
        </div>
        {title_en && <div className=" title">{title_en}</div>}
      </Grid>}
     </tr>
   
       
        <tr>
        <Grid  container size={12} 
         
           sx={
            {
             
              'paddingBottom':'2rem',
              'marginBottom':'120px'
            }
           }
       
       >
          {children}
        </Grid>
        </tr>
        <tr>
          <td className="footer" style={{'verticalAlign':'bottom'}}>
       

            <Grid  container size={12} paddingTop={0} >
               <div
                style={{ width: '100%', height: '2px', background: 'black'}}
              />
              <Grid  container size={4} paddingBottom={2} margin={0}>

              <Grid  size={12} display="flex" flexDirection={'column'}>
                <span className="title" style={{ fontSize: '1rem' }}>
                  جوال: {cookies['company_info'].phone}
                </span>
                <span
                  className="title"
                  style={{
                    fontSize: '1rem',
                    overflow: 'hidden',
                    wordBreak: 'break-all',
                  }}>
                  {cookies['company_info'].email}
                </span>
              </Grid>
              </Grid>
        
            <Grid  size={4} paddingBottom={2} margin={0}>
              <Grid  size={12} display="flex" flexDirection={'column'}
              alignItems={'center'}>
              
              </Grid>
            </Grid>
            <Grid  size={4} paddingBottom={2} margin={0} >
              <Grid  size={12} display="flex" flexDirection={'column'}
              alignItems={'end'}>
                <span className="title" style={{ fontSize: '1rem' }}>
                  {' '}
              {cookies['company_info'].country}
                </span>
                <span className="title" style={{ fontSize: '1rem' }}>
                {cookies['company_info'].city}-{cookies['company_info'].address}
                </span>
              
                
              </Grid>
            </Grid>
            </Grid>
        </td>
        </tr>
        </tbody>
      </table>
     
  );
}
